export default "__VITE_ASSET__D5yNCV0z__"